import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  CHILDREN_HEALTH_NOTIFICATIONS_ARTICLES_PATH,
  CHILDREN_HEALTH_NOTIFICATIONS_DETAILS_PATH,
  CHILDREN_HEALTH_NOTIFICATIONS_PATH,
} from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

const ChildrenHealthNotificationPage = lazy(
  () => import('./pages/ChildrenHealthNotificationPage/ChildrenHealthNotificationPage')
);
const ChildrenHealthListPage = lazy(() => import('./pages/ChildrenHealthListPage/ChildrenHealthListPage'));
const ArticlesPage = lazy(() => import('./pages/ArticlesPage/ArticlesPage'));

export const CHILDREN_HEALTH_NOTIFICATION_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.MOBILE, LayoutType.PORTAL],
    component: () => <ChildrenHealthNotificationPage />,
    displayTitle: () => "Children's Health Updates",
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_NOTIFICATIONS_DETAILS_PATH,
    serviceCatalogCode: '',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.MOBILE, LayoutType.PORTAL],
    component: () => <ChildrenHealthListPage />,
    displayTitle: () => "Children's Health Updates",
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_NOTIFICATIONS_PATH,
    serviceCatalogCode: '',
  },
  {
    availableViews: [LayoutType.MOBILE, LayoutType.PORTAL],
    component: () => <ArticlesPage />,
    displayTitle: () => `Recommended Reading`,
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_NOTIFICATIONS_ARTICLES_PATH,
    serviceCatalogCode: '',
  },
];
